<template>
  <v-app class="back">
    <v-container fluid class="doc">
      <v-row class="my-4 ml-1">
        <span class="display-1 titulo font-weight-bold">Meus Dados</span>
      </v-row>
      <v-row>
        <v-col md="9" sm="12" cols="12">
          <v-row>
            <v-card flat class="borda" width="100%">
              <v-card-text>
                <v-form
                  ref="form2"
                  v-model="valid2"
                  @submit.prevent="edit_clube()"
                >
                  <v-row>
                    <v-col cols="12" sm="12" md="8" class="mb-n5">
                      <span class="font-weight-bold black--text"
                        >Nome do clube *</span
                      >
                      <v-text-field
                        :rules="requiredRules"
                        v-model="dados_clube.clube_nome_comercial"
                        solo
                        dense
                        flat
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="4" class="mb-n5">
                      <span class="font-weight-bold black--text">Logotipo</span>
                      <v-file-input
                        prepend-icon="mdi-camera"
                        solo
                        v-model="dados_clube.clube_logotipo"
                        outlined
                        flat
                        dense
                      ></v-file-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="8" class="mb-n5">
                      <span class="font-weight-bold black--text">Email *</span>
                      <v-text-field
                        :rules="rulesAdicionalEmail"
                        v-model="dados_clube.clube_email"
                        solo
                        type="email"
                        dense
                        flat
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="4" class="mb-n5">
                      <span class="font-weight-bold black--text"
                        >Telefone *</span
                      >
                      <!-- v-mask="telefone2" -->
                      <v-text-field
                        v-model="dados_clube.clube_telefone"
                        solo
                        dense
                        v-mask="telefone2"
                        flat
                        outlined
                        :rules="rulesAdicionalTelefone"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="4" class="mb-n5">
                      <span class="font-weight-bold black--text"
                        >Tipo de empresa *</span
                      >
                      <v-select
                        :items="select_tipo_empresas"
                        :rules="rulesAdicional"
                        solo
                        v-model="dados_clube.clube_tipo_empresa"
                        outlined
                        flat
                        dense
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="mb-n5">
                      <span class="font-weight-bold black--text"
                        >Tipo de clube *</span
                      >
                      <v-select
                        :items="select_tipo_clube"
                        :rules="rulesAdicional"
                        solo
                        v-model="dados_clube.clube_tipo"
                        outlined
                        flat
                        dense
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="mb-n5">
                      <span class="font-weight-bold black--text"
                        >Hierarquia *</span
                      >
                      <v-select
                        :items="select_hierarquia"
                        :rules="rulesAdicional"
                        solo
                        outlined
                        v-model="dados_clube.clube_hierarquia"
                        flat
                        dense
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="4" class="mb-n5">
                      <v-row class="ma-0 pa-0">
                        <v-col md="auto" class="ma-0 pa-0">
                          <span class="font-weight-bold black--text"
                            >CEP *</span
                          >
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col md="auto" class="ma-0 pa-0">
                          <span v-if="cep_errado2" class="red--text">{{
                            cep_errado
                          }}</span>
                        </v-col>
                      </v-row>
                      <v-text-field
                        v-model="dados_clube.clube_cep"
                        solo
                        @blur="viaCep"
                        dense
                        v-mask="cep"
                        flat
                        outlined
                        :rules="rulesAdicional"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="8" class="mb-n5">
                      <span class="font-weight-bold black--text">Rua *</span>
                      <v-text-field
                        v-model="dados_clube.clube_rua"
                        solo
                        dense
                        flat
                        outlined
                        :rules="rulesAdicional"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="4" class="mb-n5">
                      <span class="font-weight-bold black--text">Número *</span>
                      <v-text-field
                        v-model.number="dados_clube.clube_numero"
                        solo
                        type="number"
                        dense
                        flat
                        outlined
                        :rules="rulesAdicionalNumero"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="4" class="mb-n5">
                      <span class="font-weight-bold black--text"
                        >Complemento *</span
                      >
                      <v-text-field
                        v-model="dados_clube.clube_complemento"
                        solo
                        dense
                        flat
                        :rules="rulesAdicional"
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="4" class="mb-n5">
                      <span class="font-weight-bold black--text">Bairro *</span>
                      <v-text-field
                        v-model="dados_clube.clube_bairro"
                        solo
                        dense
                        flat
                        outlined
                        :rules="rulesAdicional"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="4" class="mb-n5">
                      <span class="font-weight-bold black--text">País *</span>
                      <v-autocomplete
                        v-model="dados_clube.clube_pais"
                        solo
                        dense
                        label="Selecione"
                        :items="paises"
                        no-data-text="Não encontrado"
                        flat
                        @input="getEstados()"
                        outlined
                        :rules="rulesAdicional"
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                      v-if="brazil2 == true"
                      cols="12"
                      sm="12"
                      md="4"
                      class="mb-n5"
                    >
                      <span class="font-weight-bold black--text">Estado *</span>
                      <v-autocomplete
                        v-model="dados_clube.clube_estado"
                        solo
                        dense
                        :items="estados"
                        label="Selecione"
                        no-data-text="Não encontrado"
                        flat
                        outlined
                        @input="getCidades()"
                        :rules="rulesAdicional"
                      ></v-autocomplete>
                    </v-col>
                    <v-col v-else cols="12" sm="12" md="4" class="mb-n5">
                      <span class="font-weight-bold black--text">Estado *</span>
                      <v-text-field
                        :disabled="disable_locais2"
                        v-model="dados_clube.clube_estado"
                        solo
                        dense
                        flat
                        outlined
                        :rules="rulesAdicional"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      v-if="brazil2 == true"
                      cols="12"
                      sm="12"
                      md="4"
                      class="mb-n5"
                    >
                      <span class="font-weight-bold black--text">Cidade *</span>
                      <v-autocomplete
                        v-model="dados_clube.clube_cidade"
                        no-data-text="Não encontrado"
                        solo
                        dense
                        :items="cidades"
                        label="Selecione"
                        flat
                        outlined
                        :rules="rulesAdicional"
                      ></v-autocomplete>
                    </v-col>
                    <v-col v-else cols="12" sm="12" md="4" class="mb-n5">
                      <span class="font-weight-bold black--text">Cidade *</span>
                      <v-text-field
                        :disabled="disable_locais2"
                        v-model="dados_clube.clube_cidade"
                        solo
                        dense
                        flat
                        outlined
                        :rules="rulesAdicional"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-tooltip top v-if="!editModulo">
                      <template v-slot:activator="{ on }">
                        <v-btn icon class="mr-1" v-on="on">
                          <v-icon>mdi-information-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>
                        Sem autorização para
                        <span class="orange--text">editar</span>
                      </span>
                    </v-tooltip>
                    <v-btn
                      v-if="editModulo"
                      class="mr-3"
                      rounded
                      outlined
                      :disabled="loading_btn"
                      color="#283480"
                      @click="cancelar()"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      v-if="editModulo"
                      class="mr-3 white--text"
                      @click="edit_clube()"
                      :loading="loading_btn"
                      :disabled="loading_btn"
                      rounded
                      color="#283480"
                      >Salvar</v-btn
                    >
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
          </v-row>
        </v-col>
        <v-col md="3">
          <v-row no-gutters>
            <v-card flat width="100%" class="borda">
              <v-row justify="center">
                <v-avatar tile size="120" v-if="imgDados(fixo)">
                  <v-img contain height="120" :src="fixo.clube_logotipo" />
                </v-avatar>
                <v-avatar size="120" color="#283480" v-else>
                  <span class="white--text headline text-uppercase">{{
                    fixo.clube_nome_comercial.charAt(0)
                  }}</span>
                </v-avatar>
              </v-row>
              <v-row class="mt-5" justify="center">
                <v-card-title class="text-center">{{
                  fixo.clube_nome_comercial
                }}</v-card-title>
              </v-row>
            </v-card>
          </v-row>
          <v-row no-gutters class="mt-2">
            <v-card flat width="100%" class="borda">
              <v-card-title>Informações do plano</v-card-title>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <th class="text-left">Plano</th>
                      <th class="text-right">{{ info.plano_nome }}</th>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <th class="text-left">Total de Associados</th>
                      <th class="text-right">{{ info.total_associados }}</th>
                      <th class="text-right">
                        {{ info.total_associados_porcentagem }}%
                      </th>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-progress-linear
                rounded
                :background-color="total_associado()"
                :buffer-value="info.total_associados_porcentagem"
                height="7"
                :color="total_associado()"
                class="mx-4"
                stream
                style="width: 90% !important"
              ></v-progress-linear>

              <v-simple-table style="margin-top: 20px">
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <th class="text-left">Total de MB</th>
                      <th class="text-right">{{ info.total_mb }} MB</th>
                      <th class="text-right">
                        {{ info.total_mb_porcentagem }}%
                      </th>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-progress-linear
                rounded
                :buffer-value="info.total_mb_porcentagem"
                :background-color="total_mb()"
                height="7"
                :color="total_mb()"
                class="mx-4"
                stream
                style="width: 90% !important"
              ></v-progress-linear>
              <div v-if="editModulo">
                <v-row
                  justify="center"
                  v-if="dados_clube.clube_hierarquia >= 2"
                >
                  <v-btn
                    rounded
                    :disabled="pagarVinculo"
                    @click="dialog_pagar_vinculo = true"
                    color="#283480"
                    class="mt-8 white--text"
                  >
                    <span>Pagar vínculos</span>
                  </v-btn>
                </v-row>
                <v-row justify="center">
                  <v-btn
                    @click="AlterarPlano()"
                    rounded
                    color="#283480"
                    class="mt-4 white--text"
                  >
                    <span>Alterar Plano</span>
                  </v-btn>
                </v-row>
                <v-row justify="center">
                  <v-btn
                    @click="dialog_proxima_fatura = true"
                    rounded
                    color="#283480"
                    class="my-4 white--text"
                  >
                    <span>Próxima fatura</span>
                  </v-btn>
                </v-row>
                <v-row justify="center">
                  <v-btn
                    @click="dialog_extrato_fatura = true"
                    rounded
                    color="#283480"
                    class="mb-2 white--text"
                  >
                    <span>Extrato da Fatura</span>
                  </v-btn>
                </v-row>
                <v-row justify="center">
                  <v-btn
                    @click="dialog_cancelar_plano = true"
                    rounded
                    color="#D32F2F"
                    class="mb-2 white--text"
                  >
                    <span>Cancelar plano</span>
                  </v-btn>
                </v-row>
              </div>
            </v-card>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="modalAvisoSlug" persistent max-width="550">
      <v-card class="borda" flat>
        <v-card-title class="headline">Mudança do link do clube</v-card-title>
        <v-card-text style="text-align: justify; text-justify: inter-word">
          Com a mudança do nome do clube, o link para entrar no clube foi
          alterado.
          <br />Novo link de acesso:
          <a class="font-weight-bold" :href="app_url + fixo.clube_slug"
            >{{ app_url }}{{ fixo.clube_slug }}</a
          >
        </v-card-text>
        <v-card-actions class="mt-n2">
          <v-spacer></v-spacer>
          <v-btn
            style="
              background-color: #283480 !important;
              color: #00ffd4 !important;
            "
            rounded
            :loading="proceguir"
            :disabled="proceguir"
            @click="proceguirEdit()"
            >Ok!</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_cancelar_plano" persistent max-width="550">
      <v-card class="borda" flat v-if="!cancelando">
        <v-card-title class="headline">Cancelar plano</v-card-title>
        <v-card-text style="text-align: justify; text-justify: inter-word">
          Ao concordar com o cancelamento, a exclusão do clube estará em
          processo, e ficará 30 dias ainda disponível para cancelar a ação, caso
          a ação de exclusão do clube não seja revogado, o Meu Clube irá
          inativar o cadastro não sendo possível
          <span class="text-uppercase red--text font-weight-bold">reverter</span
          >.
        </v-card-text>
        <v-card-actions class="mt-n2">
          <v-spacer></v-spacer>
          <v-btn
            color="#283480"
            :disabled="loading_cancelar_plano"
            outlined
            rounded
            @click="dialog_cancelar_plano = false"
            >Fechar</v-btn
          >
          <v-btn
            color="#283480"
            class="white--text"
            rounded
            @click="cancelarPlano(0)"
            :disabled="loading_cancelar_plano"
            :loading="loading_cancelar_plano"
            >Cancelar plano</v-btn
          >
        </v-card-actions>
      </v-card>
      <v-card class="borda" flat v-if="cancelando">
        <v-card-title class="headline">Cancelamento em andamento</v-card-title>
        <v-card-text style="text-align: justify; text-justify: inter-word">
          O plano do clube será cancelado em: {{ cancelando }}
        </v-card-text>
        <v-card-actions class="mt-n2">
          <v-spacer></v-spacer>
          <v-btn
            color="#283480"
            :disabled="loading_cancelar_plano"
            outlined
            rounded
            @click="dialog_cancelar_plano = false"
            >Fechar</v-btn
          >
          <v-btn
            color="#283480"
            class="white--text"
            rounded
            @click="cancelarPlano(1)"
            :disabled="loading_cancelar_plano"
            :loading="loading_cancelar_plano"
            >Revogar cancelamento</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modalAlterarPlano" persistent max-width="550">
      <v-form
        ref="form3"
        v-model="valid2"
        @submit.prevent="confirmarAlterarPlano()"
      >
        <v-card class="borda" flat>
          <v-card-title class="headline">Alterar plano do clube</v-card-title>
          <v-card-text style="text-align: justify; text-justify: inter-word">
            <h3 class="black--text">Plano Atual</h3>
            <strong class="black--text">Nome do plano:</strong>
            {{ info.plano.plano_nome }}
            <br />
            <strong class="black--text">Número limite de associados:</strong>
            {{ info.plano.plano_limite_associados }} Associados
            <br />
            <strong class="black--text">Armazenamento limite do clube:</strong>
            {{ info.plano.plano_megabytes }}MB
            <br />
            <br />
            <span class="black--text">Selecione um novo plano</span>
            <v-select
              :items="select_planos"
              :rules="rulesAlterarPlano"
              solo
              outlined
              v-model="alterarPlanoInfo"
              flat
              dense
              @input="PlanoInfo()"
            ></v-select>
            <div v-if="planoInfos.id_plano">
              <v-switch
                class="my-0"
                v-if="periodoPlano == 0"
                v-model="periodoPlano"
                label="Plano Mensal"
                :true-value="1"
                :false-value="0"
              ></v-switch>
              <v-switch
                v-else
                :true-value="1"
                :false-value="0"
                class="my-0"
                v-model="periodoPlano"
                label="Plano Anual"
              ></v-switch>
              <h3 class="black--text">Novo plano</h3>
              <strong class="black--text">Nome do plano:</strong>
              {{ planoInfos.plano_nome }}
              <br />
              <strong class="black--text">Número limite de associados:</strong>
              {{ planoInfos.plano_limite_associados }} Associados
              <br />
              <strong class="black--text"
                >Armazenamento limite do clube:</strong
              >
              {{ planoInfos.plano_megabytes }}MB
              <br />
              <strong class="black--text">Descrição:</strong>
              {{ planoInfos.plano_descricao }}
              <br />
              <strong class="black--text">Valor mensal:</strong>
              R$ {{ planoInfos.plano_valor_mensal }}
              <br />
              <strong class="black--text">Valor anual:</strong>
              R$ {{ planoInfos.plano_valor_anual * 12 }} - R$
              {{ planoInfos.plano_valor_anual }}/mês
            </div>
          </v-card-text>
          <v-card-actions class="mt-n2">
            <v-spacer></v-spacer>
            <v-btn
              @click="modalAlterarPlano = false"
              rounded
              outlined
              :disabled="loadingAlterarPlano"
              color="#283480"
              >Cancelar</v-btn
            >
            <v-btn
              style="
                background-color: #283480 !important;
                color: #00ffd4 !important;
              "
              rounded
              :disabled="loadingAlterarPlano"
              :loading="loadingAlterarPlano"
              @click="dialogConfirmarAlterarPlano = true"
              >Confirmar</v-btn
            >
          </v-card-actions>
        </v-card>
        <v-dialog
          v-model="dialogConfirmarAlterarPlano"
          persistent
          max-width="450"
        >
          <v-card class="borda" flat>
            <v-card-title class="headline"
              >Mudança de plano do clube</v-card-title
            >
            <v-card-text style="text-align: justify; text-justify: inter-word"
              >Alterar o plano do clube implicará em novas
              cobranças</v-card-text
            >
            <v-card-actions class="mt-n2">
              <v-spacer></v-spacer>
              <v-btn
                @click="dialogConfirmarAlterarPlano = false"
                rounded
                outlined
                :disabled="loadingAlterarPlano"
                color="#283480"
                >Cancelar</v-btn
              >
              <v-btn
                style="
                  background-color: #283480 !important;
                  color: #00ffd4 !important;
                "
                rounded
                :disabled="loadingAlterarPlano"
                :loading="loadingAlterarPlano"
                @click="confirmarAlterarPlano()"
                >Confirmar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-form>
    </v-dialog>
    <v-dialog v-model="dialog_pagar_vinculo" max-width="480">
      <v-card flat class="borda" width="100%">
        <v-card-title class="headline titulo"
          >Pagar plano para hierarquia</v-card-title
        >
        <v-data-table
          showSelect
          :headers="cabecalho"
          :items="listaVinculos"
          loading-text="Carregando..."
          no-data-text="Nenhum item!"
          :single-select="false"
          :hide-default-footer="true"
          item-key="id_clube"
          class="elevation-0"
          show-expand
          single-expand
          @input="inputTable()"
        >
          <!-- Tabela Interior -->
          <template v-slot:expanded-item="{ item }">
            <td class="px-0" :colspan="100">
              <v-data-table
                :headers="cabecalhoSec"
                :items="item.vinculo"
                loading-text="Carregando..."
                no-data-text="Nenhum item!"
                :single-select="false"
                :hide-default-footer="true"
                :hide-default-header="true"
                item-key="id_clube"
                class="elevation-0"
              >
                <template v-slot:header.data-table-select></template>
                <template v-slot:item.clube_nome_comercial="{ item }">
                  <span>{{ item.clube_nome_comercial }}</span>
                </template>
                <template v-slot:item.status="{ item }">
                  <span
                    class="font-weight-bold red--text"
                    v-if="item.clube_disponivel"
                    >Indisponível</span
                  >
                </template>
              </v-data-table>
            </td>
          </template>
          <!--  -->
          <template v-slot:item.clube_nome_comercial="{ item }">
            <span>{{ item.clube_nome_comercial }}</span>
          </template>
          <template v-slot:item.data-table-select="{ item }">
            <!-- :disabled="
                item.clube_pagante != dados_clube.id_clube &&
                item.clube_pagante != null
              " -->
            <v-checkbox
              :disabled="
                item.clube_pagante != dados_clube.id_clube &&
                item.clube_pagante != null
              "
              @change="inputTable(item)"
              color="#283480"
              v-model="item.clube_pagante_ativo"
            ></v-checkbox>
          </template>
          <template v-slot:header.data-table-select></template>
          <template v-slot:header></template>
          <!-- 
          <template v-slot:footer>
            <v-divider></v-divider>
          </template> 
          -->
        </v-data-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="confirmarPagamentoVinculo()"
            rounded
            :loading="loadingAlterarPagamentoVinculo"
            :disabled="loadingAlterarPagamentoVinculo"
            color="#283480"
            class="white--text"
            >Confirmar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_extrato_fatura" max-width="480">
      <v-card flat class="borda" width="100%">
        <v-card-title class="headline titulo black--text"
          >Extrato da fatura</v-card-title
        >
        <v-card-text class="black--text">
          <span v-if="extrato.clubePagante != 0">
            O Clube
            <strong>{{ extrato.clubePagante.clube_nome_comercial }}</strong>
            está pagando o plano deste clube. </span
          ><br />
          <span v-if="extrato.proximaFaturaData != null">
            <strong>Proxima fatura:</strong>
            {{ extrato.proximaFaturaData }} </span
          ><br />
          <span v-if="extrato.valorPlano != null">
            <strong>Valor do plano:</strong> R$
            {{ extrato.valorPlano }}
          </span>
          <v-list dense width="100%" v-if="extrato.clubesSendoPagos">
            <v-list-item-group color="#283480">
              <v-subheader class="black--text">Clubes sendo pagos</v-subheader>
              <v-list-item
                v-for="(item, i) in extrato.clubesSendoPagos"
                :key="i"
              >
                <v-list-item-content>
                  <v-list-item-title
                    v-text="item.clube_nome_comercial"
                  ></v-list-item-title>
                  <v-list-item-subtitle
                    v-text="'R$ ' + item.valor"
                  ></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <div v-if="extrato.valorHierarquia != 0">
            <strong class="black--text">Valor Total:</strong> R$
            {{ extrato.valorHierarquia }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="dialog_extrato_fatura = false"
            rounded
            class="white--text"
            color="#283480"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_proxima_fatura" max-width="480">
      <v-card flat class="borda" width="100%">
        <v-card-title class="headline titulo black--text"
          >Próxima Fatura</v-card-title
        >
        <v-card-text class="black--text">
          <span v-if="extrato.proximaFaturaData != null">
            <strong>Data da fatura:</strong>
            {{ extrato.proximaFaturaData }} </span
          ><br />
          <span v-if="extrato.valorPlano != null">
            <strong>Valor do plano:</strong> R$
            {{ extrato.valorPlano }}
          </span>
          <div v-if="extrato.valorHierarquia != 0">
            <strong class="black--text">Valor Total:</strong> R$
            {{ extrato.valorHierarquia }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="dialog_proxima_fatura = false"
            rounded
            class="white--text"
            color="#283480"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Api from "@/common/api.helper";
import axios from "axios";
import * as locais from "../../public/json/cidades.json";
import * as paises from "../../public/json/paises.json";
export default {
  data: () => {
    return {
      valorTotal: 0,
      dialog_proxima_fatura: false,
      dialog_extrato_fatura: false,
      loading_cancelar_plano: false,
      dialog_cancelar_plano: false,
      listaVinculos: [],
      cabecalhoSec: [
        {
          text: "Nome do clube",
          align: "start",
          value: "clube_nome_comercial",
        },
        {
          text: "Status",
          value: "status",
        },
        {
          text: "Valor mensal",
          value: "plano_valor_formatado",
        },
      ],
      cabecalho: [
        {
          text: "Nome do clube",
          align: "start",
          value: "clube_nome_comercial",
        },
        {
          text: "Valor mensal",
          value: "plano_valor_formatado",
        },
        {
          text: "Valor total",
          value: "valor_total",
        },
      ],
      loadingAlterarPagamentoVinculo: false,
      modalAlterarPlano: false,
      app_url: Api.getAplicationUrl(),
      proceguir: false,
      select_tipo_empresas: [
        { text: "Micro Empreendedor Individual", value: "MEI" },
        { text: "Empresa Limitada", value: "LIMITED" },
        { text: "Empresa Individual", value: "INDIVIDUAL" },
        { text: "Associação", value: "ASSOCIATION" },
      ],
      select_tipo_clube: [
        { text: "Aberto", value: 1 },
        { text: "Semiaberto", value: 2 },
        { text: "Fechado", value: 3 },
      ],
      select_hierarquia: [
        { text: "Clube", value: 1 },
        { text: "Distrito", value: 2 },
        { text: "Distrito Múltiplo", value: 3 },
      ],
      rulesAdicionalEmail: [
        (v) => !!v || "Campo Obrigatório.",
        (v) => /.+@.+\..+/.test(v) || "E-mail inválido",
      ],
      rulesAdicionalTelefone: [
        (v) => !!v || "Campo Obrigatório.",
        (v) => (v && v.length >= 14) || "Telefone inválido",
      ],
      editar: false,
      rulesAdicional: [(v) => !!v || "Campo Obrigatório."],
      requiredRules: [(v) => !!v || "Campo Obrigatório."],
      rulesAdicionalNumero: [
        (v) => !!v | (v == 0) || "Campo Obrigatório.",
        (v) => v >= 0 || "Número deve ser maior ou igual que 0",
        (v) => /.|,/.test(v) | (v == 0) || "Apenas números permitidos",
        (v) => Number.isInteger(v) | (v == 0) || "Apenas números inteiros",
      ],
      rulesAlterarPlano: [(v) => !!v || "Selecione um plano"],
      fixo: {
        clube_nome_comercial: "",
        clube_logotipo: "",
        clube_logotipo_hash: "",
      },
      dialog_pagar_vinculo: false,
      dados_clube: {
        clube_nome_comercial: "",
        clube_cnpj: null,
        clube_logotipo: [],
        clube_hierarquia: null,
        clube_tipo: null,
        clube_email: "",
        clube_telefone: "",
        clube_cep: null,
        clube_rua: "",
        clube_numero: null,
        clube_complemento: "",
        clube_bairro: "",
        clube_cidade: "",
        clube_estado: "",
        clube_pais: "",
        clube_tipo_empresa: null,
      },
      slugMudou: false,
      editModulo: false,
      clubes_local: [],
      loading_btn: false,
      valid2: true,
      clube_atual: [],
      brazil2: false,
      disable_locais2: false,
      cep_errado2: "",
      cep_errado: "",
      cidades: [],
      estados: [],
      paises: [],
      erroIMG: false,
      tenho_cpf: false,
      cnpj_mask: "##.###.###/####-##",
      data_mask: "##/##/####",
      cpf: "###.###.###-##",
      cep: "#####-###",
      dialogConfirmarAlterarPlano: false,
      loadingAlterarPlano: false,
      select_planos: [],
      alterarPlanoInfo: null,
      planoInfos: {
        id_plano: "",
        plano_limite_associados: "",
        plano_megabytes: "",
        plano_nome: "",
        plano_descricao: "",
        plano_ativo: "",
        plano_valor_mensal: "",
        plano_valor_anual: "",
        plano_gratuito: "",
        plano_aparecer_site: "",
        plano_utilizar: "",
        plano_maximo_mensalidades: null,
        plano_codigo: null,
      },
      extrato: {
        clubePagante: 0,
        proximaFaturaData: null,
        proximaFaturaValor: null,
        valorHierarquia: 0,
        valorPlano: 0,
      },
      errorAlterarPlano: "",
      planos: [],
      pagarVinculo: true,
      info: {
        plano: [],
        plano_nome: "",
        total_associados: 0,
        total_associados_porcentagem: 0,
        total_mb: 0,
        total_mb_porcentagem: 0,
      },
      modalAvisoSlug: false,
      clubesSelecionados: [],
      cancelando: "",
      periodoPlano: 0,
    };
  },
  created() {
    this.extratoFatura();
  },
  mounted() {
    this.alterarPagamentoVinculo();
    this.getClubeAtual();
    this.getPaises();
    this.getPlanos();
    this.cancelamentoEmAndamento();
    this.validaEdicaoModulo();
    this.clubeIsento();
  },
  computed: {
    telefone2() {
      let telefone = "";
      if (this.dados_clube.clube_telefone.length > 14) {
        telefone = "(##) #####-####";
      } else {
        telefone = "(##) ####-####";
      }
      return telefone;
    },
  },
  methods: {
    extratoFatura() {
      Api.get(`/meus_dados/extratoFatura`)
        .then((response) => {
          this.extrato = response.data;
        })
        .catch((err) => {
          throw err;
        });
    },
    cancelamentoEmAndamento() {
      Api.get(`/meus_dados/cancelamentoEmAndamento`)
        .then((response) => {
          this.cancelando = response.data;
        })
        .catch((err) => {
          throw err;
        });
    },
    clubeIsento() {
      Api.get(`/meus_dados/clube-isento`)
        .then((response) => {
          this.pagarVinculo = response.data.flag;
        })
        .catch((err) => {
          this.loading_cancelar_plano = false;
          throw err;
        });
    },
    cancelarPlano(action) {
      this.loading_cancelar_plano = true;
      Api.post(`/meus_dados/cancelarAssinatura`, { action: action })
        .then((response) => {
          this.cancelamentoEmAndamento();
          this.$toast.success(response.data.success);
          this.loading_cancelar_plano = false;
          this.dialog_cancelar_plano = false;
        })
        .catch((err) => {
          this.loading_cancelar_plano = false;
          throw err;
        });
    },
    inputTable(item) {
      let index = this.clubesSelecionados.indexOf(item);
      if (index === -1) {
        this.clubesSelecionados.push(item);
      } else {
        this.clubesSelecionados.splice(index, 1);
      }
    },
    alterarPagamentoVinculo() {
      this.clubesSelecionados = [];
      Api.post(`/meus_dados/informacoes-clubes-vinculo`)
        .then((response) => {
          if (response.data) {
            this.listaVinculos = response.data;
            for (let i = 0; i < this.listaVinculos.length; i++) {
              if (this.listaVinculos[i].clube_pagante_ativo === true) {
                this.inputTable(this.listaVinculos[i]);
              }
            }
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    confirmarPagamentoVinculo() {
      this.loadingAlterarPagamentoVinculo = true;
      Api.post(`/meus_dados/confirmar-pagamento-hierarquia`, {
        clubes: this.clubesSelecionados,
      })
        .then((response) => {
          if (response.data) {
            this.$toast.success(response.data.success);
            this.dialog_pagar_vinculo = false;
          }
          this.clubesSelecionados = [];
          this.alterarPagamentoVinculo();
          this.extratoFatura();
          this.loadingAlterarPagamentoVinculo = false;
        })
        .catch((err) => {
          this.alterarPagamentoVinculo();
          this.extratoFatura();
          this.loadingAlterarPagamentoVinculo = false;
          throw err;
        });
    },
    confirmarAlterarPlano() {
      this.dialogConfirmarAlterarPlano = false;
      if (this.$refs.form3.validate()) {
        this.loadingAlterarPlano = true;
        let info = {
          periodo_plano: this.periodoPlano,
          id_plano: this.alterarPlanoInfo,
        };
        Api.post(`/meus_dados/alterar-plano`, info)
          .then((response) => {
            if (response.data.success) {
              this.$toast.success(response.data.success);
              setTimeout(function () {
                window.location.reload(true);
              }, 1100);
            } else {
              this.$toast.error(response.data.errors);
            }
            this.loadingAlterarPlano = false;
          })
          .catch((err) => {
            this.loadingAlterarPlano = false;
            throw err;
          });
      } else {
        this.errorAlterarPlano = "Selecione um plano!";
      }
    },
    AlterarPlano() {
      this.modalAlterarPlano = true;
    },
    getHash(item) {
      let url =
        Api.getApUrl() + "/meus_dados/imagem/show?img=" + item.clube_logotipo_hash;
      return url;
    },

    async validaEdicaoModulo() {
      this.editModulo = await Api.validaEdicaoModulo(
        this.$router.currentRoute.path
      );
    },
    total_mb() {
      if (this.info.total_mb_porcentagem < 70) {
        return "green";
      } else if (
        this.info.total_mb_porcentagem >= 70 &&
        this.info.total_mb_porcentagem < 85
      ) {
        return "yellow";
      } else if (this.info.total_mb_porcentagem >= 85) {
        return "red";
      }
    },
    total_associado() {
      if (this.info.total_associados_porcentagem < 70) {
        return "green";
      } else if (
        this.info.total_associados_porcentagem >= 70 &&
        this.info.total_associados_porcentagem < 85
      ) {
        return "yellow";
      } else if (this.info.total_associados_porcentagem >= 85) {
        return "red";
      }
    },
    imgDados(fixo) {
      if (fixo.clube_logotipo == Api.getApUrl()) {
        return false;
      } else {
        return true;
      }
    },
    cancelar() {
      this.getClubeAtual();
      this.getEstados();
      this.editar = true;
    },
    PlanoInfo() {
      this.errorAlterarPlano = "";
      for (let i = 0; i < this.planos.length; i++) {
        if (this.planos[i].id_plano == this.alterarPlanoInfo) {
          this.planoInfos = this.planos[i];
        }
      }
    },
    getPlanos() {
      Api.get(`/meus_dados/informacoes-plano`)
        .then((response) => {
          if (response.data) {
            this.planos = response.data.planos;

            this.info.plano = response.data.plano_info;
            this.info.id_plano = response.data.id_plano;
            this.info.plano_nome = response.data.nome_plano;
            this.info.total_associados = response.data.associados;
            this.info.total_associados_porcentagem =
              response.data.associados_porcentagem;
            this.info.total_mb = response.data.plano_megabytes;
            this.info.total_mb_porcentagem =
              response.data.plano_megabytes_porcentagem;
            for (let i = 0; i < response.data.planos.length; i++) {
              if (response.data.planos[i].id_plano != this.info.id_plano) {
                this.select_planos.push({
                  value: response.data.planos[i].id_plano,
                  text: response.data.planos[i].plano_nome,
                });
              }
            }
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    getClubeAtual() {
      this.dados_clube = JSON.parse(localStorage.getItem("clube-atual"));
      let replace = this.dados_clube.clube_telefone.replace("-", "");
      let replace2 = replace.replace("(", "");
      let replace3 = replace2.replace(")", "");
      let replace4 = replace3.replace(" ", "");
      let replace5 = replace4.replace(" ", "");
      this.dados_clube.clube_telefone = replace5;

      Api.get("/meus_dados/show/" + this.dados_clube.id_clube)
        .then((response) => {
          if (!response.data.errors) {
            this.dados_clube = Object.assign(
              this.dados_clube,
              response.data[0]
            );
            this.fixo = {
              clube_nome_comercial: this.dados_clube.clube_nome_comercial,
              clube_slug: this.dados_clube.clube_slug,
              clube_logotipo: this.dados_clube.clube_logotipo,
              clube_logotipo_hash: this.dados_clube.clube_logotipo_hash,
            };
            this.dados_clube.clube_logotipo = [];
            this.editar = true;
          } else {
            this.editar = true;
            this.$toast.warning(response.data.errors);
          }
        })
        .catch((err) => {
          this.editar = true;
          this.$toast.error(err.response.data.errors);
          throw err;
        });
    },
    sendLocalhost(item) {
      var local = {
        clube_bairro: item.clube_bairro,
        clube_cep: item.clube_cep,
        clube_cidade: item.clube_cidade,
        clube_codigo_hierarquia: item.clube_codigo_hierarquia,
        clube_complemento: item.clube_complemento,
        clube_cupom_nome: item.clube_cupom_nome,
        clube_email: item.clube_email,
        clube_estado: item.clube_estado,
        clube_hierarquia: item.clube_hierarquia,
        clube_logotipo: [],
        clube_nome_comercial: item.clube_nome_comercial,
        clube_numero: item.clube_numero,
        clube_pais: item.clube_pais,
        clube_rua: item.clube_rua,
        clube_slug: item.clube_slug,
        clube_telefone: item.clube_telefone,
        clube_tipo_plano: item.clube_tipo_plano,
        clube_token: item.clube_token,
        clubes: item.clubes,
        id_clube: item.id_clube,
        modulos: item.modulos,
      };
      var club = JSON.parse(localStorage.getItem("clubes"));

      for (let i = 0; i < club.length; i++) {
        if (club[i].id_clube == item.id_clube) {
          club[i] = local;
        }
      }
      localStorage.removeItem("clube-atual");
      localStorage.setItem("clube-atual", JSON.stringify(local));
      localStorage.setItem(`clubes`, JSON.stringify(club));
    },
    getExtension(path) {
      var basename = path.split(/[\\/]/).pop(),
        pos = basename.lastIndexOf(".");

      if (basename === "" || pos < 1) return "";

      return basename.slice(pos + 1);
    },
    proceguirEdit() {
      this.loading_btn = false;
      this.proceguir = true;
      setTimeout(function () {
        window.location.reload(true);
      }, 1100);
    },
    edit_clube() {
      this.loading_btn = true;
      if (this.$refs.form2.validate()) {
        if (this.dados_clube.clube_numero == 0) {
          this.dados_clube.clube_numero = 1;
        }
        let formData = new FormData();
        Object.keys(this.dados_clube).map((key) => {
          if (key === "clube_logotipo") {
            let file = this.dados_clube.clube_logotipo;
            if (this.dados_clube.clube_logotipo) {
              if (this.dados_clube.clube_logotipo.name) {
                formData.append(
                  `clube_logotipo`,
                  file,
                  `${new Date().getTime()}.${this.getExtension(
                    this.dados_clube.clube_logotipo.name
                  )}`
                );
              }
            }
          } else {
            if (this.dados_clube[key]) {
              formData.append(key, this.dados_clube[key]);
            }
          }
        });

        Api.post("/meus_dados/update/" + this.dados_clube.id_clube, formData)
          .then((response) => {
            if (!response.data.errors) {
              if (response.data.content) {
                this.sendLocalhost(this.dados_clube);
                this.$toast.success(response.data.content);
                this.loading_btn = false;
                setTimeout(function () {
                  window.location.reload(true);
                }, 1100);
              } else if (response.data.contentSlug) {
                this.getClubeAtual();
                this.modalAvisoSlug = true;
                this.sendLocalhost(this.dados_clube);
                this.$toast.success(response.data.contentSlug);
              } else {
                this.$toast.error("Oops, verifique os dados do clube!");
                this.loading_btn = false;
                this.loading2 = false;
              }
            } else {
              this.$toast.warning(response.data.errors);
              this.loading_btn = false;
              this.loading2 = false;
            }
          })
          .catch((err) => {
            this.loading2 = false;
            this.loading_btn = false;
            this.$toast.error(err.respose.data.errors);
            throw err;
          });
      } else {
        this.loading2 = false;
        this.loading_btn = false;
      }
    },
    viaCep() {
      if (this.dados_clube.clube_cep) {
        if (this.dados_clube.clube_cep.length != 9) {
          this.brazil2 = true;
          this.disable_locais2 = false;
        } else {
          axios
            .get(
              "https://viacep.com.br/ws/" + this.dados_clube.clube_cep + "/json"
            )
            .then((response) => {
              if (response.data.erro == true) {
                this.cep_errado2 = "CEP não encontrado";
                this.brazil2 = false;
                this.disable_locais2 = false;
              } else {
                this.brazil2 = false;
                this.disable_locais2 = true;
                this.dados_clube.clube_rua = response.data.logradouro;
                this.dados_clube.clube_cidade = response.data.localidade;
                this.dados_clube.clube_bairro = response.data.bairro;
                this.dados_clube.clube_estado = response.data.uf;
                this.dados_clube.clube_pais = "Brasil";
                this.cep_errado2 = "";
                for (let i = 0; i < locais.default.estados.length; i++) {
                  if (response.data.uf === locais.default.estados[i].sigla) {
                    this.dados_clube.clube_estado =
                      locais.default.estados[i].nome;
                  }
                }
              }
            });
        }
      }
    },
    getPaises() {
      for (let i = 0; i < paises.default.length; i++) {
        this.paises.push({
          text: paises.default[i].nome_pais + ", " + paises.default[i].sigla,
          value: paises.default[i].nome_pais,
        });
      }
      this.getEstados();
    },
    getEstados() {
      if (this.dados_clube.clube_pais == "Brasil") {
        this.brazil2 = true;
        for (let i = 0; i < locais.default.estados.length; i++) {
          this.estados.push({
            text: locais.default.estados[i].nome,
            value: locais.default.estados[i].nome,
          });
        }
        this.getCidades();
      } else {
        this.brazil2 = false;
      }
    },
    getCidades() {
      this.brazil2 = false;
      if (this.dados_clube.clube_pais == "Brasil") {
        this.brazil2 = true;
        this.cidades = [];
        for (let i = 0; i < locais.default.estados.length; i++) {
          if (
            this.dados_clube.clube_estado === locais.default.estados[i].nome
          ) {
            for (let j = 0; j < locais.default.estados[i].cidades.length; j++) {
              this.cidades[j] = locais.default.estados[i].cidades[j];
            }
          }
        }
      }
    },
  },
};
</script>

<style>
</style>